import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";
import Paginations from "../../../components/paginaton/Paginations";

const InvoiceReport = () => {
  const { branchId } = useParams();
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState("");
  const [gridData, setGridData] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const [sumOfRecords, setSumOfRecords] = useState({
    totalDiscount: 0,
    totalTax: 0,
    totalFinalPrice: 0,
    totalTipAmount: 0,
    totalPayAmount: 0,
  });
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    saleUnitId: 0,
    paymentType: 0,
    orderType: 0,
    startDate: methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD"),
    startTime: "",
    endDate: "",
    endTime: "",
    sortType: 1,
    merchantName: "",
    invoiceNumber: "",
    merchantCode: "",
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [saleUnits, setSaleUnits] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);

  const mapSumRecords = (data) => {
    sumOfRecords.totalDiscount = data.totalDiscount;
    sumOfRecords.totalTax = data.totalTax;
    sumOfRecords.totalFinalPrice = data.totalFinalPrice;
    sumOfRecords.totalTipAmount = data.totalTipAmount;
    sumOfRecords.totalPayAmount = data.totalPayAmount;
    setSumOfRecords({ ...sumOfRecords });
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getAllUnits(branchId);
    if (methods.showApiErrors(resp1)) setSaleUnits(resp1.data);

    const resp2 = await apiMethod.getOrderTypes();
    if (methods.showApiErrors(resp2)) setOrderTypes(resp2.data);

    const resp3 = await apiMethod.getPaymentTypes();
    if (methods.showApiErrors(resp3)) setPaymentTypes(resp3.data);
  };

  const downloadExcelFile = async () => {
    setLoading(true);
    const resp = await apiMethod.getSalesInvoiceExcel(filterModel);
    if (!methods.showApiErrors(resp)) return false;
    setLoading(false);
    window.location = process.env.REACT_APP_ROOT_SALE_API + "/" + resp.data;
  };

  const getGridData = async () => {
    const resp = await apiMethod.getSalesInvoiceReport(filterModel);
    if (!methods.showApiErrors(resp)) return false;

    filterModel.total = resp.total;
    filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
    setFilterModel({ ...filterModel });
    setTotalPages(resp.total);

    mapSumRecords(resp.sumOfRecords);
    setGridData(resp.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.saleUnitId = 0;
    filterModel.paymentType = 0;
    filterModel.orderType = 0;
    filterModel.startDate = methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD");
    filterModel.startTime = "";
    filterModel.endDate = "";
    filterModel.endTime = "";
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.total = 0;
    filterModel.parts = 0;
    filterModel.merchantName = "";
    filterModel.invoiceNumber = "";
    filterModel.merchantCode = "";
    setFilterModel({ ...filterModel });
    setResetKey((prev) => prev + 1);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const moduleRender = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/reports/home`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/sale/${branchId}/cashDeskManage`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                گزارش تفکیکی فاکتور
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>گزارش تفکیکی فاکتور</p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-2">
                    <label htmlFor="txtmerchantname" className="form-label">
                      نام مشتری
                    </label>
                    <input
                      id="txtmerchantname"
                      className="form-control"
                      type="text"
                      value={filterModel.merchantName}
                      onChange={(e) => {
                        filterModel.merchantName = e.target.value;
                        filterModel.part = 1;
                        setFilterModel({ ...filterModel });
                      }}
                    />
                  </div>
                  <div className="col-2">
                    <label htmlFor="txtmerchantcode" className="form-label">
                      کد اشتراک
                    </label>
                    <input
                      id="txtmerchantcode"
                      className="form-control"
                      type="text"
                      value={filterModel.merchantCode}
                      onChange={(e) => {
                        filterModel.merchantCode = e.target.value;
                        filterModel.part = 1;
                        setFilterModel({ ...filterModel });
                      }}
                    />
                  </div>
                  <div className="col-2">
                    <label htmlFor="invoicenumber" className="form-label">
                      شماره فاکتور
                    </label>
                    <input
                      id="invoicenumber"
                      className="form-control"
                      type="text"
                      value={filterModel.invoiceNumber}
                      onChange={(e) => {
                        filterModel.invoiceNumber = e.target.value;
                        filterModel.part = 1;
                        setFilterModel({ ...filterModel });
                      }}
                    />
                  </div>
                  <div className="col-2">
                    <label htmlFor="ddlStatuses" className="form-label">
                      بخش های فروش
                    </label>
                    <select
                      id="ddlStatuses"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.saleUnitId}
                      onChange={(e) => {
                        filterModel.saleUnitId = e.target.value;
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه بخش ها</option>
                      {saleUnits.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-2">
                    <label htmlFor="ddlOrderType" className="form-label">
                      نوع سفارش
                    </label>
                    <select
                      id="ddlOrderType"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.orderType}
                      onChange={(e) => {
                        filterModel.orderType = parseInt(e.target.value);
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه انواع</option>
                      {orderTypes.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-2">
                    <label htmlFor="sort" className="form-label">
                      مرتب سازی
                    </label>
                    <select
                      id="sort"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.sortType}
                      onChange={(e) => {
                        filterModel.sortType = e.target.value;
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={1}>جدیدترین ها</option>
                      <option value={0}>قدیمیترین ها</option>
                    </select>
                  </div>
                  <div className="col-2">
                    <label htmlFor="ddlPaymentType" className="form-label">
                      نوع پرداخت
                    </label>
                    <select
                      id="ddlPaymentType"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.paymentType}
                      onChange={(e) => {
                        filterModel.paymentType = parseInt(e.target.value);
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه انواع</option>
                      {paymentTypes.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="startDate" className="form-label">
                      از تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.startDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.startDate = value.format("YYYY/MM/DD");
                        else filterModel.startDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="startTime" className="form-label">
                      از ساعت
                    </label>
                    <DatePicker
                      key={`startTime-${resetKey}`}
                      disableDayPicker
                      format="HH:mm"
                      plugins={[
                        <TimePicker
                          hideSeconds
                          value={filterModel.startTime}
                        />,
                      ]}
                      onChange={(value) => {
                        if (value)
                          filterModel.startTime = value.format("HH:mm");
                        else filterModel.startTime = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="enddate" className="form-label">
                      تا تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.endDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.endDate = value.format("YYYY/MM/DD");
                        else filterModel.endDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="endTime" className="form-label">
                      تا ساعت
                    </label>
                    <DatePicker
                      key={`endTime-${resetKey}`}
                      disableDayPicker
                      format="HH:mm"
                      plugins={[
                        <TimePicker hideSeconds value={filterModel.endTime} />,
                      ]}
                      onChange={(value) => {
                        if (value) filterModel.endTime = value.format("HH:mm");
                        else filterModel.endTime = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
                <div className="mt-3 text-center">
                  <div className="">
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info me-1"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-success"
                      onClick={() => {
                        downloadExcelFile();
                      }}
                    >
                      <i className="bi bi-file-earmark-excel"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-3">
                        مجموع تخفیف:{" "}
                        {methods.addNumSeperator(sumOfRecords.totalDiscount)}
                      </div>
                      <div className="col-3">
                        مجموع مالیات:{" "}
                        {methods.addNumSeperator(sumOfRecords.totalTax)}
                      </div>
                      <div className="col-3">
                        مجموع مبالغ:{" "}
                        {methods.addNumSeperator(sumOfRecords.totalFinalPrice)}
                      </div>
                      <div className="col-3">
                        مجموع پرداختی:{" "}
                        {methods.addNumSeperator(sumOfRecords.totalPayAmount)}
                      </div>
                    </div>
                  </div>
                </div>

                <table className="table table-striped table-md">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">بخش فروش</th>
                      <th scope="col vertical-center">شماره فاکتور</th>
                      <th scope="col vertical-center">نام مشتری</th>
                      <th scope="col vertical-center">نوع سفارش</th>
                      <th scope="col vertical-center">سرویس ها</th>
                      <th scope="col vertical-center">جمع تخفیف</th>
                      <th scope="col vertical-center">مالیات</th>
                      <th scope="col vertical-center">مبلغ فاکتور (ریال)</th>
                      <th scope="col vertical-center">تاریخ</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <td>
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </td>
                        <td>{item.saleUnitTitle}</td>
                        <td>{item.invoiceNumber}</td>
                        <td>{item.merchantName}</td>
                        <td>{item.orderTypeName}</td>
                        <td>
                          {item.services.length > 0 && (
                            <table className="table">
                              <tbody>
                                {item.services.map((item, sixd) => (
                                  <tr key={sixd}>
                                    <td>{item.productName}</td>
                                    <td>
                                      {methods.addNumSeperator(item.finalPrice)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </td>
                        <td>{methods.addNumSeperator(item.totalDiscount)}</td>
                        <td>{methods.addNumSeperator(item.totalTax)}</td>
                        <td>{methods.addNumSeperator(item.totalFinalPrice)}</td>
                        <td>
                          <div>
                            ایجاد:{" "}
                            {methods.toPersianDate(
                              item.createDate,
                              "jYYYY/jMM/jDD - HH:mm"
                            )}
                          </div>
                          <div>
                            پرداخت:{" "}
                            {methods.toPersianDate(
                              item.paymentDate,
                              "jYYYY/jMM/jDD - HH:mm"
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* {filterModel.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )} */}
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={totalPages}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return <>{moduleRender()}</>;
};

export default InvoiceReport;
